<!--  -->
<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>统计管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">统计管理</div>
        <!-- <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="searchPro"
          style="width:230px;margin-top:20px;"
        /> -->
      </div>
      <div class="header-tool-box">
        <div
          class="htb-item"
          @click="
            show = true;
            title = '添加统计项';
          "
        >
          <i class="icon iconfont icon-downLoad2"></i><span>添加统计项</span>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <div v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="name">{{ row.title }}</template>
          <template slot-scope="{ row }" slot="lianjie">{{ row.defaultUrl }}</template>
          <template slot-scope="{ row }" slot="spectatorCount">{{
            row.countNum
          }}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff; cursor: pointer" @click="QRShow(row)">编辑</span>
            <span style="display: inline-block; padding: 0 5px">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00; cursor: pointer">删除</span>
            </Poptip>
          </template>
        </Table>
        <!-- <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div> -->
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <!-- <iModal
      :title="title"
      v-model="show"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="show = false"
      @on-ok="addChannel('formInline')"
    >
    <Form
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      label-position="left"
      :label-width="100"
    >
    
      <FormItem label="统计名称" prop="Name">
        <Input type="text" v-model="formInline.Name"></Input>
      </FormItem>
    </Form>
    </iModal> -->

    <el-dialog :title="title" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form
        :model="formInline"
        :rules="ruleInline"
        ref="formInline"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="统计名称" prop="Name">
          <el-input v-model="formInline.Name" size="small"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('formInline'),show=false" size="small">取消</el-button>
        <el-button type="danger" @click="addChannel('formInline')" size="small" style="background:#d13119;    border: 1px solid #d13119;">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          title: "统计名称",
          slot: "name",
          align: "center",
          //width: 240
        },
        {
          title: "统计链接",
          slot: "lianjie",
          align: "center",
          //width: 240
        },
        {
          title: "点击次数",
          slot: "spectatorCount",
          align: "center",
          //width: 240
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      title: "添加统计项",
      list: [],
      pageSize: 10,
      pageIndex: 1,
      totalCount: "",
      show: false,
      formInline: {
        Name: "",
      },
      ruleInline: {
        Name: [
          {
            required: true,
            message: "请输入统计名称",
            trigger: "blur",
          },
        ],
      },
      QRshow: false,
      path: "",
      dataId: "",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getChannelList: "hostCommonModule/getChannelList",
      AddChannel: "hostCommonModule/AddChannel",

      LinkClickTotalGetAll: "hostCommonModule/LinkClickTotalGetAll",
      LinkClickTotalPost: "hostCommonModule/LinkClickTotalPost",
      LinkClickTotalPut: "hostCommonModule/LinkClickTotalPut",
      LinkClickTotalDelete: "hostCommonModule/LinkClickTotalDelete",
    }),

  

    async init() {
      let opt = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,

        Wheres: {
          Type: 1,
          Wheres: {
            Label: "targetType",
            Value: "4",
          },
        },
      };
      let data = await this.LinkClickTotalGetAll(opt);
      if (data && data && data.length > 0) {
        this.list = data;
      }
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    QRShow(row) {
      this.title = "修改统计项";
      this.formInline.Name = row.title;
      this.dataId = row.id;
      this.show = true;
    },

    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      },

    async addChannel(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      if (this.title == "添加统计项") {
        let opt = {
          title: this.formInline.Name,
        };
        let data = await this.LinkClickTotalPost(opt);
      }
      if (this.title == "修改统计项") {
        let opt = {
          id: this.dataId,
          setValues: {
            Title: this.formInline.Name,
          },
        };
        let data = await this.LinkClickTotalPut(opt);
      }
      this.formInline.Name = "";
      this.show = false;
      this.init();
    },
    async delItem(e) {
      let data = await this.LinkClickTotalDelete(e.id);
      this.init();
    },
  },
};
</script>
<style scoped lang="scss">
/* @import url(); 引入css类 */

// .el-button:focus, .el-button:hover{
//     color: #fff;
//     border-color: #fff;
//     background-color: #fff;
// }
</style>
